import { db } from "../firebase";
import { doc, setDoc, collection } from "firebase/firestore";

export default function useUpdateDoc({ coll }) {
    const update = (id, data, options) => {
        const docRef = doc(collection(db, coll), id);
        return setDoc(docRef, data, { merge: true, ...options });
    }
    return { update }
}